'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const CheckboxGroup = (props) => {
  const _a = props, {
    commonStyle,
    inputStyle,
    labelStyle,
    optionStyle,
    register,
    name,
    id,
    options = []
  } = _a, rest = __objRest(_a, [
    "commonStyle",
    "inputStyle",
    "labelStyle",
    "optionStyle",
    "register",
    "name",
    "id",
    "options"
  ]);
  return /* @__PURE__ */ jsxRuntime.jsx(Wrapper, {
    commonStyle,
    id,
    children: options.map((el) => /* @__PURE__ */ jsxRuntime.jsxs(StyledLabelWrapper, {
      style: { display: "flex", alignItems: "center" },
      children: [
        /* @__PURE__ */ jsxRuntime.jsx(StyledInput, __spreadProps(__spreadValues({
          inputStyle,
          value: el.value
        }, register ? register(name, rest) : __spreadValues({ name }, rest)), {
          type: "checkbox"
        })),
        /* @__PURE__ */ jsxRuntime.jsx(StyledLabel, {
          labelStyle: optionStyle,
          children: el.label
        })
      ]
    }, el.value))
  });
};
const Wrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  ${coreRenderer.getStyle(commonStyle)}
`
);
const StyledLabel = styled__default["default"].div(
  ({ labelStyle }) => `
  margin-left: 0.25rem;
  vertical-align: middle;
  width: -webkit-fill-available;
  ${coreRenderer.getStyle(labelStyle)}
`
);
const StyledLabelWrapper = styled__default["default"].label`
  vertical-align: middle;
  margin-bottom: 0;
`;
const StyledInput = styled__default["default"].input(
  ({ inputStyle }) => `
  ${coreRenderer.getStyle(inputStyle)}
`
);

exports.CheckboxGroup = CheckboxGroup;
